<template>
    <div id="data-view">
        <dv-full-screen-container>
            <div class="main-header">
                <div class="mh-left">
                    <span style="margin-left:100px">{{ currentDateStr }}</span>
                </div>
                <dv-decoration-8 style="width:300px;height:50px;" />
                <div class="mh-middle">北碚区智慧危险废物监测监管</div>
                <dv-decoration-8 :reverse="true" style="width:300px;height:50px;" />

                <div class="mh-right">
                    <dv-border-box-2
                        style="width: 120px; height: 50px; line-height: 50px; text-align:center;margin-left:220px;">
                        <div @click="toManage()" style="cursor:pointer;">管理平台</div>
                    </dv-border-box-2>
                </div>
            </div>

            <dv-border-box-1 class="main-container">
                <div class="left-container">
                    <div style="height:20%">
                        <Home-Page-Total />
                    </div>
                    <div style="height:40%;">
                        <Enterprise-Total-Top-5 />
                    </div>
                    <div style="height:40%">
                        <Hw-Type-Top-5 />
                    </div>
                </div>
                <div class="center-container">
                    <EnterpriseMap style="height:60%" />
                    <box1 style="height:40%" />
                </div>
                <div class="right-container">
                    <div style="height:60%">
                        <Enterise-List />
                    </div>
                    <div style="height:40%;">
                        <Alarm-Event />
                    </div>
                    <!-- <div style="height:40%">
                        <Alarm-Chart />
                    </div> -->
                </div>
            </dv-border-box-1>
        </dv-full-screen-container>
    </div>
</template>

<script>

import EnterpriseTotalTop5 from './EnterpriseTotalTop5'
import HwTypeTop5 from './HwTypeTop5'
import HomePageTotal from './HomePageTotal'
import AlarmEvent from './AlarmEvent'
import AlarmChart from './AlarmChart'
import EnterpriseMap from './EnterpriseMap'
import box1 from './box1'
import EnteriseList from './EnteriseList'
// import FlowChart from "./FlowChart";

export default {
    name: 'DataView',
    components: {
        EnterpriseTotalTop5,
        HwTypeTop5,
        HomePageTotal,
        EnterpriseMap,
        AlarmEvent,
        AlarmChart,
        box1,
        // FlowChart,
        EnteriseList
    },
    methods: {
        toManage() {
            window.open('https://mgr-wfb.cdfirst.net')
        },
        getCurrentDate() {
            var myDate = new Date()
            var myYear = myDate.getFullYear() // 获取完整的年份(4位,1970-????)
            var myMonth = myDate.getMonth() + 1 // 获取当前月份(0-11,0代表1月)
            var myToday = myDate.getDate() // 获取当前日(1-31)
            var myDay = myDate.getDay() // 获取当前星期X(0-6,0代表星期天)
            var myHour = myDate.getHours() // 获取当前小时数(0-23)
            var myMinute = myDate.getMinutes() // 获取当前分钟数(0-59)
            var mySecond = myDate.getSeconds() // 获取当前秒数(0-59)
            var week = [
                '星期日',
                '星期一',
                '星期二',
                '星期三',
                '星期四',
                '星期五',
                '星期六'
            ]

            var nowTime =
                myYear +
                '年' +
                this.fillZero(myMonth) +
                '月' +
                this.fillZero(myToday) +
                '日' +
                '  ' +
                this.fillZero(myHour) +
                ':' +
                this.fillZero(myMinute) +
                ':' +
                this.fillZero(mySecond) +
                '  ' +
                week[myDay] +
                '  '
            this.currentDateStr = nowTime
        },
        fillZero(str) {
            var realNum
            if (str < 10) {
                realNum = '0' + str
            } else {
                realNum = str
            }
            return realNum
        }
    },
    mounted() {
        setInterval(() => {
            this.getCurrentDate()
        }, 1000)
    },
    data() {
        return {
            currentDateStr: ''
        }
    }
}
</script>

<style lang="less">
@import "../../assets/css/style/common.css";
@import "../../assets/css/style/zoom.css";

#data-view {
    width: 100%;
    height: 100%;
    background-color: #030409;
    color: #fff;

    #dv-full-screen-container {
        background-image: url("../../assets/image/bg.png");
        background-size: 100% 100%;
        box-shadow: 0 0 3px blue;
        display: flex;
        flex-direction: column;
    }

    .main-header {
        height: 80px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        .mh-left {
            font-size: 20px;
        }

        .mh-middle {
            font-size: 32px;
        }

        .mh-left,
        .mh-right {
            width: 450px;
        }
    }

    .main-container {
        height: calc(~"100% - 80px");

        .border-box-content {
            padding: 20px;
            box-sizing: border-box;
            display: flex;
        }
    }

    .left-container {
        width: 25%;
    }

    .center-container {
        width: 50%;
    }

    .right-container {
        width: 25%;
    }
}
</style>
